import axios from "axios"
import { axiosClient } from "./axiosClient"

export const ROLL_API = '/api/v1/roll'

export const addRollByPurchase = (body) => {
    return axiosClient.post(`${ROLL_API}/add-by-purchase`, body)
}

export const updateRollByPurchase = (id, body) => {
    return axiosClient.put(`${ROLL_API}/update-by-purchase/${id}`, body)
}

export const deleteRollByPurchase = (id) => {
    return axiosClient.delete(`${ROLL_API}/delete-by-purchase/${id}`)
}

export const addRollByPlan = (body) => {
    return axiosClient.post(`${ROLL_API}/add-by-plan`, body)
}

export const updateRollByPlan = (id, body) => {
    return axiosClient.put(`${ROLL_API}/update-by-plan/${id}`, body)
}

export const getAllRolls = ({ purchaseId = "", productionPlanId = "" }) => {
    return axiosClient.get(`${ROLL_API}/all?purchaseId=${purchaseId}&productionPlanId=${productionPlanId}`)
}

export const addRoll = (body) => {
    return axiosClient.post(ROLL_API, body)
}

// export const addRollByPlan = (body) => {
//     return axiosClient.post(`${ROLL_API}/add-by-plan`, body)
// }

export const addRollByStock = (body) => {
    return axiosClient.post(`${ROLL_API}/add-by-stock`, body)
}

export const updateRollByStock = (id, body) => {
    return axiosClient.put(`${ROLL_API}/update-by-stock/${id}`, body)
}

// export const updateRollByPlan = (id, body) => {
//     return axiosClient.put(`${ROLL_API}/update-by-plan/${id}`, body)
// }

export const getRollByUpc = (upc) => {
    return axiosClient.get(`${ROLL_API}/upc/${upc}`)
}

export const getRollById = (id) => {
    return axiosClient.get(`${ROLL_API}/${id}`)
}

export const getPageRolls = ({ page = 0, lastId = '', upc = "", productId = "", collectionId = '', colorId = '', locationId = "", boilerCode = "", quantity = "", restQuantity = "", unitPrice = "", hasMore = true }) => {
    return axiosClient.get(`${ROLL_API}/page?page=${page}&lastId=${lastId}&upc=${upc}&productId=${productId}&collectionId=${collectionId}&colorId=${colorId}&locationId=${locationId}&boilerCode=${boilerCode}&quantity=${quantity}&restQuantity=${restQuantity}&unitPrice=${unitPrice}&hasMore=${hasMore}`)
}

export const getSumRolls = ({ upc = "", collectionId = '', colorId = '', locationId = "", boilerCode = "", hasMore = true }) => {
    return axiosClient.get(`${ROLL_API}/sum?upc=${upc}&collectionId=${collectionId}&colorId=${colorId}&locationId=${locationId}&boilerCode=${boilerCode}&hasMore=${hasMore}`)
}

export const deleteRoll = (id) => {
    return axiosClient.delete(`${ROLL_API}/${id}`)
}

export const deleteRollByPlan = (id) => {
    return axiosClient.delete(`${ROLL_API}/delete-by-plan/${id}`)
}

export const updateStockRoll = (id, body) => {
    return axiosClient.put(`${ROLL_API}/stock/${id}`, body)
}

export const uploadStockExcelFile = (body) => {
    return axiosClient.post(`${ROLL_API}/upload-excel`, body)
}

export const getNextUpc = () => {
    return axiosClient.get(`${ROLL_API}/next-upc`)
}

export const downloadRollExcelFile = ({ upc = "", collectionId = '', colorId = '', locationId = "", boilerCode = "", hasMore = true }) => {
    return axiosClient.get(`${ROLL_API}/download-excel?upc=${upc}&collectionId=${collectionId}&colorId=${colorId}&locationId=${locationId}&boilerCode=${boilerCode}&hasMore=${hasMore}`, {
        responseType: 'arraybuffer',
    })
}